module.exports = __webpack_public_path__ + "media/56_Long.c620f818.mp3";